import { useEffect, useState } from 'react'
import { message } from 'antd'
import dayjs from 'dayjs'
import courseEnrollmentsReportService from '../../Services/Reports/EnrollentCourseReportService'
import { CourseRankingSort } from 'Common/Constants/Enums/Individual/Reports/CourseRankingSortEnum'

export default function useCourseEnrollmentsReport() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false) // Guard for double download
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [totalCount, setTotalCount] = useState(0)

  const [filters, setFilters] = useState({
    SortBy: CourseRankingSort.Enrollments,
  })

  const fetchReport = async (params) => {
    setLoading(true)
    try {
      const res = await courseEnrollmentsReportService.getReport(params)
      setData(res.data.items || [])
      setTotalCount(res.data.totalCount || 0)
    } catch (error) {
      console.error("API Error:", error)
      message.error('Failed to load course enrollments')
    } finally {
      setLoading(false)
    }
  }

  const downloadReport = async (params) => {
    if (isDownloading) return; // Prevent double execution
    setIsDownloading(true);

    try {
      message.loading({ content: 'Generating PDF...', key: 'dl' });

      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error('Download timed out')), 60000)
      );
      
      const res = await Promise.race([
        courseEnrollmentsReportService.downloadReport(params),
        timeoutPromise
      ]);

      if (!res.data || res.data.size === 0) {
        throw new Error('Server returned empty response');
      }

      const applicationName = "CoreIQPro";
      const dateStr = dayjs().format('MMM-DD-YYYY');
      const filename = `${applicationName}-Course-Enrolls-Report-${dateStr}.pdf`;

      const blob = new Blob([res.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }, 500); // Increased cleanup time slightly to prevent browser-level double triggers

      message.success({ content: 'PDF downloaded', key: 'dl' });
    } catch (error) {
      console.error("Download Error:", error);
      message.error({ content: 'Download failed', key: 'dl' });
    } finally {
      setIsDownloading(false);
    }
  };

  // NOTE: useEffect removed from here to prevent duplicate initial fetch.
  // The component's useEffect will handle the initial mount.

  return {
    data,
    loading,
    isDownloading, // Return this new state
    pageNumber,
    pageSize,
    totalCount,
    filters,
    setFilters,
    setPageNumber,
    setPageSize,
    fetchReport,
    downloadReport,
  }
}